import { rem, Skeleton } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getMIPInvestorInvestmentValuationsData } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service.ts';
import { HoldingsSummary } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/HoldingsSummaryCard/HoldingsSummary.tsx';
import { getHoldingsTotals } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/HoldingsSummaryCard/holdingsSummary.utils.ts';

interface Props {
	investorId: string;
}

export const HoldingsSummaryCard = ({ investorId }: Props) => {
	const valuationsQuery = useQuery({
		queryKey: [API_PATHS.MIP_INVESTOR_VALUATIONS_ID_GET, { investorId }],
		queryFn: ({ signal }) =>
			getMIPInvestorInvestmentValuationsData(
				API_PATHS.MIP_INVESTOR_VALUATIONS_ID_GET,
				{ investorId },
				signal
			),
	});

	if (valuationsQuery.isPending) {
		return <Skeleton height={rem(100)} radius="0.5rem" />;
	}

	const valuations = valuationsQuery.data?.payload;
	const loanCurrencies = new Set((valuations?.loans ?? []).map((l) => l.currency));
	const loanCurrency = loanCurrencies.size === 1 ? [...loanCurrencies][0] : undefined;

	return (
		<HoldingsSummary
			totals={getHoldingsTotals(valuations)}
			currency={valuations?.currency}
			loanCurrency={loanCurrency}
			isError={valuationsQuery.isError}
		/>
	);
};
